module.exports = __webpack_public_path__ + "img/Check.57ac7ffe.svg";